import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, ShoppingCart, User, MessageCircle } from 'lucide-react';
import './BottomNav.css';

function BottomNav({ cartCount, customer }) {
  const location = useLocation();

  const navItems = [
    { to: '/', label: 'Home', icon: Home },
    { to: '/collection', label: 'Shop', icon: ShoppingBag },
    { to: '/cart', label: 'Cart', icon: ShoppingCart, badge: cartCount },
    { to: '/contact', label: 'Contact', icon: MessageCircle },
    { to: customer ? '/account' : '/login', label: customer ? 'Account' : 'Login', icon: User },
  ];

  return (
    <nav className="bottom-nav">
      {navItems.map(item => {
        const isActive = location.pathname === item.to ||
          (item.to === '/collection' && location.pathname.startsWith('/collection'));
        return (
          <Link
            key={item.to}
            to={item.to}
            className={`bottom-nav-item ${isActive ? 'active' : ''}`}
          >
            <div className="bottom-nav-icon-wrap">
              <item.icon size={22} />
              {item.badge > 0 && <span className="bottom-nav-badge">{item.badge}</span>}
            </div>
            <span className="bottom-nav-label">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}

export default BottomNav;
